// useGeneralDocumentClasses.ts
import { useState, useEffect } from 'react';
import { DocumentClass } from '../apiTypes';
import { fetchGeneralDocumentClasses } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export function useGeneralDocumentClasses() {
  useAxiosInterceptor();

  const [documents, setDocuments] = useState<DocumentClass[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadDocuments = async () => {
      setLoading(true);
      try {
        const data = await fetchGeneralDocumentClasses();
        setDocuments(data);
        setError(null);
     //   console.log('✅ General Document Classes:', data);
      } catch (err) {
        setError('Errore caricamento documenti generali');
        console.error('❌ Errore caricamento documenti generali:', err);
      } finally {
        setLoading(false);
      }
    };

    loadDocuments();
  }, []);

  return { documents, loading, error };
}
